module.exports = __webpack_public_path__ + "img/Carla-Robles-Gutierrez.77f688aa.jpg";